import { Grid, IconButton } from '@mui/material'
import { GetApp, Preview } from '@mui/icons-material'
import { green } from '@mui/material/colors'
import PropTypes from 'prop-types'
import patientExaminationDownload from '../../../../lib/patientExaminationDownload'
import { useDispatch, useSelector } from 'react-redux'
import { openPopup } from '../../../../store/popupsSlice'

const PatientsTableActions = ({ row }) => {
  const user = useSelector((state) => state.user.user)
  const dispatch = useDispatch()
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      direction="row"
      spacing={1}
      className="table-actions"
    >
      {row.comment && user.role_id === 1 && (
        <Grid
          item
          onClick={() =>
            dispatch(
              openPopup({
                component: 'NotePreview',
                title: `Podgląd notatki`,
                level: 1,
                maxWidth: 'xl',
                key: 'examinaton-component-preview-popup',
                values: {
                  content: row.comment,
                },
              })
            )
          }
        >
          <IconButton title="Podgląd" size="small">
            <Preview fontSize="small" />
          </IconButton>
        </Grid>
      )}
      {row.file_id && (
        <Grid item onClick={() => patientExaminationDownload(row.id)}>
          <IconButton title="Pobierz" size="small">
            <GetApp fontSize="small" style={{ color: green[500] }} />
          </IconButton>
        </Grid>
      )}
    </Grid>
  )
}

PatientsTableActions.propTypes = {
  row: PropTypes.object,
}

export default PatientsTableActions
